import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { CoreService } from 'src/app/core/helpers/core.service';

@Component({
    selector: 'loyaltic-select-slot',
    templateUrl: './select-slot.component.html',
    styleUrls: ['./select-slot.component.scss'],
    standalone: false
})
export class SelectSlotComponent implements OnInit {

  slotsInfo: any;
  slots: any;
  userId = '';

  constructor(private readonly router: Router, private authService: AuthService,
    private coreService: CoreService,) { }

  ngOnInit() {
    this.userId = this.authService.getUserId();
    this.getAvailableSlots();

  }

  navigateToEnterCode(slot: string) {
    localStorage.setItem('slotNumber', slot);
    this.router.navigate(['/enter-code'])
  }

  getAvailableSlots() {
    this.coreService.getAvailableSlots(this.userId).then((response: any) => {
      this.slotsInfo = response.result.slotsInfo;
    })
  }

}
